import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ParallaxSection from './components/ParallaxSection';
import GallerySection from './components/GallerySection';
import TeamSection from './components/TeamSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import { heroImages } from './data/mock';
import './App.css';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ParallaxSection 
        sloganIndex={0}
        imageUrl={`${heroImages[3]}?w=1920&q=80`}
      />
      <ServicesSection />
      <ParallaxSection 
        sloganIndex={1}
        imageUrl={`${heroImages[4]}?w=1920&q=80`}
      />
      <GallerySection />
      <TeamSection />
      <ParallaxSection 
        sloganIndex={2}
        imageUrl="https://customer-assets.emergentagent.com/job_studio149-barber/artifacts/cybeld34_Ana%20pere%20kosu.jpg"
      />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Toaster 
        position="top-center"
        toastOptions={{
          style: {
            background: '#1a1a1a',
            color: '#fff',
            border: '1px solid #0067ff'
          }
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
